import * as React from "react";
import styled from "styled-components";
import { Badge, RowTitleButton, Row } from "common/components";
import useExpandedSections from "components/common/EntityDataTable/hooks/useExpandedSections";
import { requiredLicenseMessage } from "illuminate/components/content-hub/utils";
const Title = styled(RowTitleButton)`
  & * {
    color: ${({ theme, $disabled }) => $disabled ? theme.colors.text.disabled : theme.colors.link.default} !important;
  }
`;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
`;
const TitleRenderer = ({ pack }) => {
  const { toggleSection } = useExpandedSections();
  const toggleExtraSection = () => toggleSection(pack.pack_id, "restFieldsExpandedSection");
  return /* @__PURE__ */ React.createElement(TitleContainer, null, /* @__PURE__ */ React.createElement(Title, { $disabled: !(pack.is_compatible && pack.included_in_bundle), onClick: toggleExtraSection }, pack.title), !pack.included_in_bundle && /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "xxs" }, /* @__PURE__ */ React.createElement(Badge, { variant: "danger", size: "xs", solid: true }, requiredLicenseMessage(pack.license))));
};
const StatusRenderer = ({ pack }) => {
  if (!pack.is_new && !pack.update_available) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "xxs" }, pack.is_new && /* @__PURE__ */ React.createElement(Badge, { variant: "success", size: "xs", solid: true }, "new"), pack.update_available && /* @__PURE__ */ React.createElement(Badge, { variant: "info", size: "xs", solid: true }, "updated"));
};
export const columnRenderers = {
  attributes: {
    title: {
      width: 0.2,
      renderCell: (_title, pack) => /* @__PURE__ */ React.createElement(TitleRenderer, { pack })
    },
    enabled: {
      staticWidth: 150,
      renderCell: (enable) => enable ? /* @__PURE__ */ React.createElement(Badge, { variant: "success" }, "enabled") : null
    },
    type: {
      staticWidth: 130,
      renderCell: (type) => /* @__PURE__ */ React.createElement(Badge, null, type)
    },
    status: {
      staticWidth: 150,
      renderCell: (_status, pack) => /* @__PURE__ */ React.createElement(StatusRenderer, { pack })
    },
    category: {
      staticWidth: 150,
      renderCell: (category) => /* @__PURE__ */ React.createElement(Badge, null, category)
    },
    pack_id: {
      staticWidth: 300
    }
  }
};
